require("./exantCostETF.scss");

// @ vendor
const React = require("react");
const PropTypes = require("prop-types");
const { FormattedText, formatText } = require('core/i18n').i18n;
import { withRouter } from "react-router-dom";

// @components
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");

// @helpers
const {
    formatAmount,
    formatCurrency,
    formatWithoutRound,
    formatPercentage
} = require('utilities/currencyHelper');
// @ constants
const {
    CHARGE_ACCOUNT_PREFIX,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_LIMITED,
    POTENTIAL_SELL_ETF_COTS,
    POTENTIAL_COST,
    POTENTIAL_COST_TYPE
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class ExantCostETF extends React.Component {
    constructor(props) {
        super(props);

        this.buildDetails = this.buildDetails.bind(this);
        this.buildLeftColumn = this.buildLeftColumn.bind(this);
        this.buildRightColumn = this.buildRightColumn.bind(this);
    }

    componentDidMount() {
        const { fetchExtantCostETFBuy, history } = this.props
        fetchExtantCostETFBuy(history);
    }

    getOrderType(orderType) {
        if (orderType === BROKER_ORDER_TYPE_TO_MARKET) {
            return formatText('brokerETFBuy-ETFBuyStep1ToMarketLabel');
        } else if (orderType === BROKER_ORDER_TYPE_FOR_THE_BEST) {
            return formatText('brokerETFBuy-ETFBuyStep1ForTheBestLabel');
        } else {
            return formatText('brokerETFBuy-ETFksBuyStep1LimitedLabel');
        }
    }

    buildLeftColumn() {
        const { stockDescription, step1, stockContract, immETFBuy } = this.props;
        const titleQuantity = step1.get('titleQuantity');
        const orderType = step1.get('orderTypeOption');
        const orderTypeText = this.getOrderType(orderType);
        const validityDate = step1.get('validityDate');
        const formattedValidityDate = validityDate
            ? validityDate.format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))
            : '-';
        const controlDigit = stockContract.get('controlDigit');
        const productNumber = stockContract.get('productNumber');
        const walletNumber = stockContract.get('walletNumber');
        const contractValues = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${walletNumber}`;
        const associatedAccountAlias = stockContract.get('associatedAccountAlias');
        const associatedAccount = stockContract.get('associatedAccount')
        const balanceLabel = formatText('brokerETFBuy-summaryBalanceTitle');
        const walletBalance = stockContract.getIn(['associatedAccountBalance', 'amount']);
        const walletCurrency = stockContract.getIn(['associatedAccountBalance', 'currency']);

        const descriptionAccount = `${associatedAccountAlias} ${associatedAccount} (${balanceLabel}: ${formatAmount(walletBalance)} ${formatCurrency(walletCurrency)})`
        let estimatedAmount = `${formatWithoutRound(walletBalance)} ${formatCurrency(walletCurrency)}`;
        const dataExtant = immETFBuy.getIn(['exAnteCostsList']);
        const estimatedBaseAmount = dataExtant.get('estimatedBaseAmount');
        const estimatedBaseAmountExchanged = dataExtant.get('estimatedBaseAmountExchanged');
        if (!!estimatedBaseAmount) {
            const estimatedBaseAmountValue = estimatedBaseAmount.get('amount');
            const estimatedBaseAmountCurrency = estimatedBaseAmount.get('currency');
            if (!!estimatedBaseAmountExchanged) {
                const estimatedBaseAmountExchangedValue = estimatedBaseAmountExchanged.get('amount');
                const estimatedBaseAmountExchangedCurrency = estimatedBaseAmountExchanged.get('currency')
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(
                    estimatedBaseAmountCurrency
                )} | ${formatWithoutRound(
                    estimatedBaseAmountExchangedValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountExchangedCurrency)}`;
            } else {
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountCurrency)}`;
            }
        }
        const orderTypeValue = step1.get('orderTypeValue');
        const orderTypeInfo = orderType === BROKER_ORDER_TYPE_LIMITED
            ? `(${formatWithoutRound(orderTypeValue, 2)} ${formatCurrency(walletCurrency)})`
            : '';
        return (
            <div className="broker-buy-etf-description__left-column-container">
                <div className="broker-buy-etf-description__column-title">
                    <FormattedText value="brokerETFBuy-orderDataTitle" />
                </div>
                <BrokerDataItem
                    label={"brokerETFBuy-ETFToBuy"}
                    data={stockDescription}
                />
                <BrokerDataItem
                    label={"brokerETFBuy-estimatedAmount"}
                    data={estimatedAmount}
                    tooltipTitleKey={`brokerETFBuy-estimatedAmountTooltipTitle`}
                    tooltipContentKey={`brokerETFBuy-estimatedAmountComplexTooltip`}
                    eventCategory="orden compra acciones/paso 2"
                    eventTag={"orden de compra/importe base estimado"}
                    complexTooltip
                />
                <BrokerDataItem
                    label={"brokerETFBuy-participations"}
                    data={titleQuantity}
                />
                <BrokerDataItem
                    label={"brokerETFBuy-orderType"}
                    data={`${orderTypeText} ${orderTypeInfo}`}
                />
                <BrokerDataItem
                    label={"brokerETFBuy-validityPeriod"}
                    data={formattedValidityDate}
                />
                <BrokerDataItem
                    label={"brokerETFBuy-valueContact"}
                    data={contractValues}
                />
                <BrokerDataItem
                    label={"brokerETFBuy-firstHolder"}
                    data={stockContract.get('firstTitular')}
                />
                <BrokerDataItem
                    label={"brokerETFBuy-associatedAccount"}
                    data={descriptionAccount}
                />
            </div>
        );
    }

    buildRightColumn() {
        const { immETFBuy } = this.props;
        const dataExtant = immETFBuy.getIn(['exAnteCostsList']);
        const exAnteCostList = dataExtant.getIn(['exAnteCostList']);
        let data, potentialSellETFCostsText;
        if (immETFBuy.getIn(['exAnteDataFetching'])) {
            data = <LoadingSection />;
        } else if (exAnteCostList) {
            data = exAnteCostList.map((item, index) => (
                item.get('type') !== POTENTIAL_COST &&
                (
                    <BrokerExAntSection
                        context="brokerETFBuy"
                        eventCategory="orden compra fondos/paso 2"
                        section={item}
                        key={index}
                        complexTooltip={true}
                    />
                )
            ));

            const potentialSellETFCosts = exAnteCostList.find(
                (item) => item.get("descriptionKey") === POTENTIAL_SELL_ETF_COTS
            );

            if (potentialSellETFCosts && potentialSellETFCosts.get('type') === POTENTIAL_COST) {

                const dataPotentialCosts = potentialSellETFCosts.get('details').toJS()[0];
                const currency = formatCurrency(dataPotentialCosts.currency ? dataPotentialCosts.currency : 'EUR');
                const amount = formatWithoutRound(dataPotentialCosts.amount, 2);
                const immPercentage = formatPercentage(dataPotentialCosts.percentage, 2);
                const formatAmount = `${amount} ${currency}`

                potentialSellETFCostsText = formatText('brokerETFBuy-exantCost_potentialCost_footer', [formatAmount, immPercentage]);
            }
        }
        return (
            <div className="broker-buy-etf-description__right-column-container">
                {data}
                {potentialSellETFCostsText &&
                    <div>
                        {potentialSellETFCostsText}
                    </div>
                }
            </div>
        );
    }

    buildDetails(title, footer = null) {
        return (
            <React.Fragment>
                <div className="broker-buy-etf-description__title-description">
                    {title}
                </div>
                <div className="broker-buy-etf-description__web-wrapper__container">
                    {this.buildLeftColumn()}
                    {this.buildRightColumn()}
                </div>
                <span className="broker-buy-etf-description__footer">
                    {footer}
                </span>
            </React.Fragment>
        );
    }

    renderExtantDataWeb() {
        const { immETFBuy } = this.props;
        const dataExtant = immETFBuy.getIn(['exAnteCostsList']);
        const exAnteCostList = dataExtant.getIn(['exAnteCostList']);
        const potentialSellETFCosts = exAnteCostList && exAnteCostList.find(
            (item) => item.get("descriptionKey") === POTENTIAL_SELL_ETF_COTS
        );
        return (
            <div className="broker-buy-etf-description__web-wrapper">
                <div className="broker-buy-etf-description__web-wrapper__container">
                    {this.buildLeftColumn()}
                    {this.buildRightColumn()}
                </div>
                {potentialSellETFCosts && potentialSellETFCosts.get('type') === POTENTIAL_COST_TYPE &&
                    <div className="broker-buy-etf-description__footer">
                        <FormattedText
                            value="brokerETFBuy-extantCost_footer_description"
                        />
                    </div>
                }

            </div>
        );
    }

    render() {
        return __CONTACT_CENTER__ ? (
            <BlockInfo extraClass="broker-buy-etf-description__block-info">
                {this.buildDetails(
                    formatText('brokerETFBuy-extantCost_description_cc'),
                    formatText('brokerETFBuy-extantCost_footer_description_cc')
                )}
            </BlockInfo>
        ) : (
            <div>
                {this.renderExtantDataWeb()}
            </div>
        );
    }
}

ExantCostETF.propTypes = {
    productCurrency: PropTypes.object.isRequired,
    productIso: PropTypes.object.isRequired,
    productType: PropTypes.object.isRequired,
    stockContract: PropTypes.object.isRequired,
    stockDescription: PropTypes.object.isRequired,
    step1: PropTypes.object.isRequired,
    fetchExtantCostETFBuy: PropTypes.func.isRequired,
    immETFBuy: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = ExantCostETF;

export default withRouter(ExantCostETF);
